import { render, staticRenderFns } from "./DefaultProperty.vue?vue&type=template&id=f7a67faa&"
import script from "./DefaultProperty.vue?vue&type=script&lang=js&"
export * from "./DefaultProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports